module.exports = __webpack_public_path__ + "img/kibana.2512a623.png";